import React from "react";
import { CompanyRow } from "./CompanyRow";
import { getCountryByCode } from "../../../../utils/Helper";
import { useGetCompanyQuery } from "../../../../store/Company/companyApiSlice";
/* The WorldBox lookup lives in the search slice, not the company one — the
   same two imports PurchaseList uses. */
import { useGetCompanyNewQuery } from "../../../../store/search/searchApiSlice";

/* One purchased company. Transcribed from components/common/PurchaseList.jsx, including its shape: a TREVEX id (TRX…) resolves through getCompany, anything... */
export const PurchasedRow = ({ companyID, purchaseDate, token }) => {
  const isTrevex = String(companyID || "").startsWith("TRX");

  const { data } = useGetCompanyQuery(
    { token, companyId: isTrevex ? companyID : "" },
    { skip: !isTrevex }
  );
  const { data: worldBoxCompany } = useGetCompanyNewQuery(
    { id: isTrevex ? "" : companyID },
    { skip: isTrevex }
  );

  const name = isTrevex
    ? data?.registered_company_name
    : worldBoxCompany?.company?.name;

  const state =
    isTrevex && data?.companyAddress?.[0]?.company_address_detailsID?.state
      ? `${data.companyAddress[0].company_address_detailsID.state}, `
      : "";
  const country = getCountryByCode(
    isTrevex ? data?.country_code : worldBoxCompany?.company?.countrycode
  );

  return (
    <CompanyRow
      divided
      name={name || ""}
      location={`${state}${country || ""}`.trim()}
      trailing={
        /* Pushed to the row's trailing edge, away from the name. */
        <span className="ml-auto flex shrink-0 items-center gap-[9px] text-right">
          <CalendarIcon />
          <span className="block">
            <span className="block text-[11.5px] text-[var(--muted)] font-sans">
              Purchased on
            </span>
            <span className="mt-0.5 block text-[14px] font-semibold text-[var(--ink)] font-sans">
              {purchaseDate}
            </span>
          </span>
        </span>
      }
    />
  );
};

const CalendarIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    aria-hidden="true"
    className="shrink-0 text-[var(--muted-2)]"
  >
    <rect x="3" y="5" width="18" height="16" rx="2" />
    <path d="M3 10h18M8 3v4M16 3v4" strokeLinecap="round" />
  </svg>
);

export default PurchasedRow;
